import { GroupModel } from "model/Group.model";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = GroupModel | null;

export const useDefaultObservableGroupModelNull = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectGroupModelNull extends BehaviorSubject<CurrentType> {}
